export default __webpack_public_path__ + "static/micaturnsone-f910eb6e8af53c8d03d4209c140a1400.svg";